function getCPMPriority(simulator){
    var readyTasks = simulator.projectPool.getAllReadyTasks(simulator.projectPool.projects);
    slackTimes = getSlackTimes(simulator);
    

    readyTasks.sort((task1,task2) => {
        var task1Slack = slackTimes[task1.project.projectIndex][task1.taskName];
        var task2Slack = slackTimes[task2.project.projectIndex][task2.taskName];
        
        return task1Slack - task2Slack ||  task1.project.projectIndex - task2.project.projectIndex;
    })

    return readyTasks;
}

function getSlackTimes(simulator){
    slackTimes = [];
    earliestTimes = getEarliestTimes(simulator);
    latestTimes = getLatestTimes(simulator);


    simulator.projectPool.projects.forEach((project, projectIndex) => {
        currSlackTimes = {};
        project.taskArray.forEach(task => {
            currSlackTimes[task.taskName] = latestTimes[projectIndex][task.taskName]["start"] - earliestTimes[projectIndex][task.taskName]["start"];
        });

        slackTimes.push(currSlackTimes);
    });

    return slackTimes;
}

function getEarliestTimes(simulator){
    var earliestStarts = [];

    allTasks = simulator.projectPool.projects.forEach(project => {
        var projectES = {}

        function getEarliestStarts(task){
            if(task.parentTasks.length == 0){
                return {"start": task.startHour, "end": task.startHour + (task.totalWorkHours - task.currWorkedHours)};
            }
    
            task.parentTasks.forEach(parentTask => {
                if(projectES[parentTask.taskName] == null){
                    projectES[parentTask.taskName] = getEarliestStarts(parentTask);
                }
            });
    
            var parentEndHours = []
            task.parentTasks.forEach(parentTask => {
                parentEndHours.push(projectES[parentTask.taskName]["end"]);
            });
    
            var earliestStart = Math.max(Math.max(...parentEndHours), simulator.hoursPassed);
             
            return {"start": earliestStart, "end": earliestStart + (task.totalWorkHours - task.currWorkedHours)};
        }

        project.taskArray.forEach(task => {
            projectES[task.taskName] = getEarliestStarts(task);
        });

        earliestStarts.push(projectES);
    });

    return earliestStarts;

}

function getLatestTimes(simulator){
    var latestTimes = [];

    allTasks = simulator.projectPool.projects.forEach(project => {
        var projectLT = {}

        function getLatestTimes(task){
            if(task.childTasks.length == 0){
                return {"start": task.project.getDueDate() - (task.totalWorkHours - task.currWorkedHours), "end": task.project.getDueDate()};
            }
    
            task.childTasks.forEach(childTask => {
                if(projectLT[childTask.taskName] == null){
                    projectLT[childTask.taskName] = getLatestTimes(childTask);
                }
            });
    
            var childStartHours = []
            task.childTasks.forEach(childTask => {
                childStartHours.push(projectLT[childTask.taskName]["start"]);
            });
    
            var latestStart = Math.min(...childStartHours);
             
            return {"start": latestStart - (task.totalWorkHours - task.currWorkedHours), "end": latestStart};
        }

        project.taskArray.forEach(task => {
            projectLT[task.taskName] = getLatestTimes(task);
        });

        latestTimes.push(projectLT);
    });

    return latestTimes;
}


module.exports = {getCPMPriority}